import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import user_image from '../../assets/images/user.svg'
import users_image from '../../assets/images/users.svg'
import add_img from '../../assets/images/add.svg'
import lock_image from './images/lock.svg'
import settings_img from '../../assets/images/nav_icons/settings.svg'

import GroupTable from './_components/GroupTable'
import GroupModal from './_components/GroupModal'

import './UserSettings.css'

import { useTour } from "@reactour/tour"
import { selectUserData, selectUserOnboarding, updateUserOnboarding } from "../../features/User/userSlice"
import { usersTourSteps } from "../../config/tour"

export default function UsersGroupsScreen () {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const [showNewGroupModal, setShowNewGroupModal] = useState(false)
    const [filter, setFilter] = useState({
        deleted: false,
        active: false,
        suspended: false,
        waiting: false,
        is_admin: false,
        skip: 0,
        limit: 20
    })

    const userOnboarding  = useSelector(selectUserOnboarding)
    const userData = useSelector(selectUserData)
    const { setIsOpen, setCurrentStep, setSteps, setMeta } = useTour()
    
    useEffect(()=>{
        setIsOpen(false)
        if(!userOnboarding?.users?.section_completed && userOnboarding?.users?.step_completed_count <= 3 && !userData?.is_super_admin){
            if(userOnboarding?.users?.step_completed_count === 1){
                dispatch(
                updateUserOnboarding({
                    onboarding_step: {
                        step_completed_count: 2,
                        section_completed: false,
                        section: 'users'
                    }
                })
            );
            }
            setTimeout(()=>{
                if(window.location.pathname?.includes("users"))
                    setIsOpen(true)
            },2000)
            setSteps(usersTourSteps(navigate))
            setCurrentStep(userOnboarding?.users?.step_completed_count === 1 ? 2 : userOnboarding?.users?.step_completed_count)
            setMeta('users')
        } 
    },[])

    return(
        <section id="usersScreen">
            <div className='d-flex align-items-center justify-content-between'>
                <div className='d-flex'>
                    <NavLink to={'/users'}>
                        <div className="page_title not_active">
                            <img src={user_image} />
                            <h1>{t.users.users}</h1>
                        </div>
                    </NavLink>
                    <NavLink to={'/users/groups'}>
                        <div className="page_title active ms-4">
                            <img src={users_image} />
                            <h1>{t.users.groups}</h1>
                        </div>
                    </NavLink>
                    <NavLink to={'/users/admins'}>
                        <div className="page_title not_active ms-4">
                            <img src={lock_image} />
                            <h1>{t.users.admin}</h1>
                        </div>
                    </NavLink>
                </div>
                <div className='d-flex align-items-center'>
                    <button onClick={()=>setShowNewGroupModal(true)}>
                        {t.groups.new_group}
                        <img src={add_img} />
                    </button>
                    <NavLink to={'/users/settings'} state={{from: location.pathname }}>
                        <div className="page_title not_active ms-4 users-step-3">
                            <img className='ms-2' src={settings_img} />
                        </div>
                    </NavLink>
                </div>
            </div>
            <div className='mt-3 users-step-2'>
                <GroupTable defaultFilters={filter}/>
            </div>
            <GroupModal isNew={showNewGroupModal}  onCloseModal={()=>setShowNewGroupModal(false)}/>
        </section>
        
    )
}